import React, { useRef } from 'react';
import { ExpandableMenuProps } from 'src/app/molecules/Header/Header/HeaderLinks';
import { ProMegaMenuSideContainer } from './MightyProMegaMenu.styles';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import MightyProMegaMenuFeatures from './MightyProMegaMenuFeatures';
import useElementResize from 'src/hooks/useElementResize';

const MightyProMegaMenuSideBar = ({ isOpen }: ExpandableMenuProps): JSX.Element => {
  const menuContainerRef = useRef<HTMLDivElement>(null);
  const { height } = useElementResize(menuContainerRef);

  return (
    <ProMegaMenuSideContainer
      isOpen={isOpen}
      maxHeight={height}
    >
      <Stack
        ref={menuContainerRef}
        direction='column'
      >
        <MightyProMegaMenuFeatures />
      </Stack>
    </ProMegaMenuSideContainer>
  );
};

export default MightyProMegaMenuSideBar;
